import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.dialog = new window.A11yDialog(this.element)
    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)

    this.element.addEventListener("show", this.handleShow)
    this.element.addEventListener("hide", this.handleHide)
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd)
    document.addEventListener("click", this.handleTriggerClick)

    if (this.element.dataset.a11yDialogAutoOpen === "true") {
      this.dialog.show()
    }
  }

  disconnect() {
    this.element.removeEventListener("show", this.handleShow)
    this.element.removeEventListener("hide", this.handleHide)
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
    document.removeEventListener("click", this.handleTriggerClick)

    this.unlockBodyScroll()

    if (this.dialog) this.dialog.destroy()
  }

  handleTriggerClick = (event) => {
    const trigger = event.target.closest(`[data-a11y-dialog-show="${this.element.id}"]`)
    if (!trigger) return

    const form = this.element.querySelector("form")
    if (!form) return

    if (trigger.dataset.formUrl) form.action = trigger.dataset.formUrl
  }

  handleSubmitEnd = (event) => {
    if (!event.detail.success) return

    const contentType = event.detail.fetchResponse?.contentType || ""
    if (contentType.startsWith("text/vnd.turbo-stream.html")) return

    this.dialog?.hide()
  }

  handleShow() {
    this.element.removeAttribute("hidden")
    this.lockBodyScroll()
    this.initializeSelect2()
    this.applyDefaultValues()
    this.activateFields()
  }

  handleHide() {
    this.element.setAttribute("hidden", "true")
    this.unlockBodyScroll()
    this.resetDialog()
  }

  lockBodyScroll() {
    if (this.bodyScrollLocked) return

    const currentCount = this.bodyLockCount

    if (currentCount === 0) {
      this.storeBodyOverflow()
      document.body.style.overflow = "hidden"
    }

    this.setBodyLockCount(currentCount + 1)
    this.bodyScrollLocked = true
  }

  unlockBodyScroll() {
    if (!this.bodyScrollLocked) return

    const nextCount = Math.max(0, this.bodyLockCount - 1)

    if (nextCount === 0) {
      this.restoreBodyOverflow()
      this.clearBodyLockCount()
    } else {
      this.setBodyLockCount(nextCount)
    }

    this.bodyScrollLocked = false
  }

  get bodyLockCount() {
    return Number.parseInt(document.body.dataset.a11yDialogLockCount || "0", 10) || 0
  }

  setBodyLockCount(count) {
    document.body.dataset.a11yDialogLockCount = String(count)
  }

  clearBodyLockCount() {
    delete document.body.dataset.a11yDialogLockCount
  }

  storeBodyOverflow() {
    document.body.dataset.a11yDialogPreviousOverflow = document.body.style.overflow || ""
  }

  restoreBodyOverflow() {
    document.body.style.overflow = document.body.dataset.a11yDialogPreviousOverflow || ""
    delete document.body.dataset.a11yDialogPreviousOverflow
  }

  initializeSelect2() {
    const selects = window.$(this.element).find("select.select2:not(.select2-hidden-accessible)")

    window.mdSelect2(selects, { closeOnSelect: false })
  }

  resetDialog() {
    const container = window.$(this.element)

    container.resetMdFields()
    container.removeMdErrors()
  }

  activateFields() {
    if (!window.mdFormHelper) return

    window.mdFormHelper.activateMdFields(window.$(this.element))
  }

  applyDefaultValues() {
    this.element.querySelectorAll("[data-default-value]").forEach((field) => {
      if (field.dataset.defaultValue) {
        field.value = field.dataset.defaultValue
      }
    })
  }
}
